<template>
    <div class="reports-general">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Relatórios</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <mu-form :model="form">
            <mu-row gutter>
                <mu-col span="12" sm="6" md="6" lg="6" xl="6">

                    <!-- Seleção da empresa caso for Ziad ou Revenda -->
                    <mu-select label="Selecione a empresa" filterable no-data-text="Nenhuma empresa encontrada" v-model="form.content.company_id" full-width v-if="isHaveClients">
                        <mu-option v-for="(item, index) in options.clients" :key="`company_${index}`" :label="item.label" :value="item.id"></mu-option>
                    </mu-select>

                    <!-- Seleção se é para ter os clientes também -->
                    <mu-select label="Relatório completo com os clientes?" v-model="form.content.clients" full-width v-if="isFullReport()">
                        <mu-option label="Não" :value="false"></mu-option>
                        <mu-option label="Sim" :value="true"></mu-option>
                    </mu-select>

                    <!-- Título -->
                    <mu-text-field v-model.trim="form.title" full-width label="Título *"></mu-text-field>

                    <!-- Descrição -->
                    <mu-text-field v-model.trim="form.description" full-width multi-line :rows="3" :rows-max="3" label="Descrição *"></mu-text-field>

                    <!-- Selecionar se quer Envios, Recebimentos ou Todos -->
                    <mu-form-item prop="radio" label="Selecione quais serviços *" style="margin-bottom: 0;">
                        <mu-radio v-model="form.content.service" value="all" label="Envios e Respostas"></mu-radio>
                        <mu-radio v-model="form.content.service" value="sent" label="Envios"></mu-radio>
                        <mu-radio v-model="form.content.service" value="received" label="Respostas"></mu-radio>
                        <mu-radio v-model="form.content.service" value="received_with_send" label="Resposta com o envio **"></mu-radio>
                        <mu-radio v-model="form.content.service" value="tts" label="TTS"></mu-radio>
                    </mu-form-item>
                    <ul class="alert-description">
                        <li>** <u>Resposta com o envio</u> é um relatório para conferência da resposta juntamente com a mensagem que foi enviada.</li>
                    </ul>

                    <!-- Data inicial e final -->
                    <mu-row gutter>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <mu-date-input :date.sync="form.content.start_at" v-model="form.content.start_at" label="Data inicial *" format="DD-MM-YYYY" :should-disable-date="notAllowedStartDates" :date-time-format="options.format" full-width></mu-date-input>
                        </mu-col>
                        <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                            <mu-date-input :date.sync="form.content.end_at" v-model="form.content.end_at" label="Data final *" format="DD-MM-YYYY" :should-disable-date="notAllowedEndDates" :date-time-format="options.format" full-width></mu-date-input>
                        </mu-col>
                    </mu-row>

                    <!-- Gerar relatório -->
                    <mu-button color="primary" round @click="save()" :disabled="!validateForm()">
                        Gerar Relatório
                    </mu-button>

                </mu-col>
                <mu-col span="12" sm="6" md="6" lg="6" xl="6">
                </mu-col>
            </mu-row>

            <br>
            <br>
        </mu-form>

    </div>
</template>

<script>
    import moment from 'moment'
    import DateFormatCalendar from '@/helpers/calendar'
    import ClientService from '@/services/settings/clients'
    import ReportsService from '@/services/services/reports'

    export default {
        name: 'app-reports-create',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Relatórios',
                        route: 'app.services.reports',
                        disabled: false
                    },
                    {
                        text: 'Relatório Analítico',
                        route: 'app.services.reports.analytical.index',
                        disabled: false
                    },
                    {
                        text: 'Criar Relatório',
                        disabled: true
                    }
                ],
                options: {
                    format: DateFormatCalendar,
                    clients: []
                },
                form: {
                    type: 'date',
                    title: '',
                    description: '',
                    content: {
                        service: 'all',
                        start_at: new Date(),
                        end_at: new Date(),
                        company_id: null,
                        campaign_id: null,
                        users: []
                    }
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pegamos os dados da empresa gravadas no STATE
             */
            companie () {
                return this.$store.state.company || null
            },

            /**
             * Verificamos se a empresa logada é uma Revenda ou é a Ziad
             */
            isHaveClients () {
                return this.isZiad() || (this.companie && this.companie.customType === 'R')
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            this.loadClients()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de clientes que a revenda logada possui
             */
            async loadClients () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando as informações necessárias para gerar o relatório.')

                    let result = await ClientService.all()

                    if (result && result.status) {
                        let arrayOptions = result.results.map((item) => {
                            return {
                                id: item.id,
                                label: item.nick_name,
                                custom_type: item.custom_type
                            }
                        })
                        if (this.isZiad()) {
                            this.options.clients = arrayOptions
                        } else {
                            this.options.clients = [
                                { id: this.companie.id, label: this.companie.name, custom_type: this.companie.customType },
                                ...arrayOptions
                            ]
                        }
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar os clientes.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são maiores que a data final
             * - Datas que são maiores que 90 dias da data final
             * @param date Data que será feito a validação
             */
            notAllowedStartDates (date) {
                if (date > this.form.content.end_at || moment(this.form.content.end_at).diff(date, 'days') > 200) {
                    return true
                }
                return false
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são menores que a data de inicio
             * - Datas que são maiores que a data atual
             * @param date Data que será feito a validação
             */
            notAllowedEndDates (date) {
                if (date < this.form.content.start_at || date > new Date()) {
                    return true
                }
                return false
            },

            /**
             * Faz uma validação dos dados antes de enviar
             */
            validateForm () {
                // if (!this.form.content.company_id && this.isHaveClients) return false
                if (!this.form.title) return false
                if (!this.form.description) return false
                if (!this.form.content.start_at) return false
                if (!this.form.content.end_at) return false
                return true
            },

            isFullReport () {
                if (this.isZiad()) {
                    let search = this.options.clients.find((item) => {
                        return item.id === this.form.content.company_id
                    })
                    if (search) {
                        if (this.form.content.company_id === this.companie.id || search.custom_type === 'R') {
                            return true
                        }
                    }
                    return false
                }
                if (this.form.content.company_id === this.companie.id) {
                    return true
                }
                return false
            },

            /**
             * Criamos uma requisição para API do JSReport com os dados necessários para montar
             * um arquivo de relatório, passamos na propriedade 'data' todas as informações necessárias
             * para a montagem do relatório
             */
            async save () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Processando o relatório.')

                    // Verificando se não existir um client_id
                    if (this.form.content.company_id === null) {
                        this.form.content.company_id = this.companie.id
                    }

                    // Monta o JSON para salvar no content
                    this.form.content.start_at = `${moment(this.form.content.start_at).format('YYYY-MM-DD')} 00:00:00`
                    this.form.content.end_at = `${moment(this.form.content.end_at).format('YYYY-MM-DD')} 23:59:59`
                    this.form.content.campaign_id = null

                    // Formatando dados para o envio
                    let data = {
                        type: this.form.type,
                        title: this.form.title,
                        description: this.form.description,
                        content: JSON.stringify(this.form.content)
                    }

                    // Faz a requisição
                    let result = await ReportsService.store(data)

                    if (result && result.status) {
                        this.$eventHub.$emit('loading', false)
                        this.$eventHub.$emit('snackbar', 'success', 'O relatório entrou na fila para processamento.')
                        this.$router.push({ name: 'app.services.reports.analytical.index' })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('loading', false)
                    this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o relatório..')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../../assets/stylus/bootstrap.styl'

    .mu-select-content
        .mu-selection-text
            display none !important

    .reports-general

        .mu-table
            width 100%
            background none
            color darken($grey, 30%)
            tr
                height auto
                &:hover
                    background lighten($grey, 70%)
                    color #000
                th
                    background lighten($grey, 50%)
                    padding 6px 2px 2px 6px
                    font-size 12px
            td
                padding 6px 2px 2px 6px
                font-size 12px

        table, th, td
            border-collapse collapse

        .box-options
            padding-bottom 15px

            .mu-button
                margin-right 10px

        .alert-description
            margin-bottom 30px
            color $orange
            background lighten($orange, 85%)
            border 1px lighten($orange, 70%) solid
            padding 5px
            list-style none

</style>
